export default "__VITE_ASSET__hVypKXNN__"